import React, { useState, useEffect } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import "../../styles/Header-css/Hedaer/LocationInput.css";

const LocationInput = ({ selectedLocation, setSelectedLocation }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempLocation, setTempLocation] = useState("");
  const [locationSuggestions, setLocationSuggestions] = useState([]);

  const openModal = () => {
    setTempLocation(selectedLocation);
    setIsModalOpen(true);
    setLocationSuggestions([]);
  };

  const handleUseCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
          );
          const data = await res.json();
          setTempLocation(data.display_name || "Current Location");
          setLocationSuggestions([]);
        } catch (err) {
          alert("Failed to fetch location.");
        }
      });
    } else {
      alert("Geolocation not supported.");
    }
  };

  const handleConfirmLocation = () => {
    if (tempLocation.trim() !== "") {
      setSelectedLocation(tempLocation);
      setIsModalOpen(false);
    }
  };

  const handleCancelLocation = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (tempLocation.trim().length < 3) {
        setLocationSuggestions([]);
        return;
      }

      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${tempLocation}&format=json&addressdetails=1&limit=5`
        );
        const data = await response.json();
        setLocationSuggestions(data);
      } catch (error) {
        console.error("Error fetching location suggestions:", error);
      }
    };

    const debounce = setTimeout(fetchSuggestions, 400);
    return () => clearTimeout(debounce);
  }, [tempLocation]);

  const handleSelectSuggestion = (place) => {
    setTempLocation(place.display_name);
    setLocationSuggestions([]);
  };

  return (
    <>
      <div className="input-group" onClick={openModal}>
        <FaMapMarkerAlt className="input-icon" />
        <input
          type="text"
          className="header-input"
          placeholder="Select location"
          value={selectedLocation}
          readOnly
        />
      </div>

      {isModalOpen && (
        <div className="location-modal-overlay">
          <div className="location-modal">
            <h2>Select Your Location</h2>
            <input
              type="text"
              className="location-input"
              placeholder="Search or type address..."
              value={tempLocation}
              onChange={(e) => setTempLocation(e.target.value)}
            />

            {locationSuggestions.length > 0 && (
              <ul className="location-suggestions">
                {locationSuggestions.map((place, index) => (
                  <li key={index} onClick={() => handleSelectSuggestion(place)}>
                    {place.display_name}
                  </li>
                ))}
              </ul>
            )}

            <button
              className="location-btn use-current"
              onClick={handleUseCurrentLocation}
            >
              Use Current Location
            </button>

            <div className="location-btn-group">
              <button className="location-btn cancel" onClick={handleCancelLocation}>
                Cancel
              </button>
              <button
                className="location-btn confirm"
                onClick={handleConfirmLocation}
                disabled={!tempLocation.trim()}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LocationInput;